module.exports = __webpack_public_path__ + "img/pc-delete.80b62e76.svg";